import React, { memo,useMemo, useEffect, useState } from 'react'
import './customSelect.css'
import { MdClose, MdOutlineKeyboardArrowDown, MdOutlineKeyboardArrowUp } from "react-icons/md";

const CustomSelect = ({
  placeholder = "Search",
  data = [],
  name,
  defaultValue,
  onChange,
  error,
  title,
  isRequired = true
}) => {
  const [show, setShow] = useState(false)
  const [text, setText] = useState('')
  const [internalValue, setInternalValue] = useState(defaultValue)

  // Handle defaultValue changes and async loading
  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== '') {
      const selectedItem = data.find(item => item.key == defaultValue)
      if (selectedItem) {
        setText(selectedItem.value)
        setInternalValue(defaultValue)
      }
    } else {
      setText('')
      setInternalValue('')
    }
  }, [defaultValue, data])

  const btnHandler = (item) => {
    setShow(false)
    setText(item.value)
    setInternalValue(item.key)
    onChange(item.key)
  }

  const clearValue = () => {
    setText('')
    setInternalValue('')
    onChange('')
  }

  const toggleDropdown = () => {
    setShow(prev => !prev)
  }

  const filteredData = useMemo(() => {
    return data.filter(pre => 
      pre?.value?.toLowerCase().includes(text?.toLowerCase())
    )
  }, [data, text])

  return (
    <div className="custom-select mainSearchBar">
      <div className="form-group mb-0">
        <label htmlFor={name}>
          {title}
          {isRequired ? (
            <span className="text-danger"> *</span>
          ) : (
            <span>&nbsp;(Optional)</span>
          )}
        </label>
        <div className='inputContainer'>
          <input
            type="text"
            placeholder={placeholder}
            name={name}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onFocus={() => setShow(true)}
            className='form-control'
            autoComplete='off'
          />

          {text && (
            <MdClose 
              size={30} 
              className='icon' 
              onClick={clearValue} 
              aria-label="Clear selection"
            />
          )}
          {show ? (
            <MdOutlineKeyboardArrowDown 
              size={30} 
              className='icon' 
              onClick={toggleDropdown} 
              aria-label="Close dropdown"
            />
          ) : (
            <MdOutlineKeyboardArrowUp 
              size={30} 
              className='icon' 
              onClick={toggleDropdown} 
              aria-label="Open dropdown"
            />
          )}
        </div>
      </div>
      {error && <span className='error text-danger'>{error}</span>}
      {show && (
        <ul className="selectOption">
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <li 
                onClick={() => btnHandler(item)} 
                key={item.key}
                aria-selected={internalValue === item.key}
              >
                {item.value}
              </li>
            ))
          ) : (
            <li className="no-results">No Result Found</li>
          )}
        </ul>
      )}
    </div>
  )
}

export default memo(CustomSelect)